export default {
	seo_meta_title_leaguepass: 'NBA | Video dan Sorotan NBA',
	seo_meta_desc_leaguepass: 'Video NBA menampilkan video dan sorotan NBA',
	seo_meta_keywords_leaguepass: 'Video NBA, Sorotan NBA, Video Bola Keranjang, perlawanan penting, dunk, ciri-ciri',
	seo_meta_title_featured: 'NBA | Paparan Utama',
	seo_meta_desc_featured: '',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA | Siaran Langsung NBA TV',
	seo_meta_desc_nbatv: 'NBA TV Siaran Langsung membawakan anda saluran NBA TV 24 jam sehari dengan penstriman perlawanan NBA secara langsung dan dari arkib setiap minggu, jadual program Studio dan liputan penganalisis',
	seo_meta_keywords_nbatv: 'Saluran NBA TV, rentak perlawanan, program Hardwood Classics, NBA siaran langsung, program NBA Gametime, tinjauan fantasi, rancangan studio, program the Jump',
	seo_meta_title_classicgames: 'NBA | Perlawanan Klasik',
	seo_meta_desc_classicgames: '',
	seo_meta_keywords_classicgames: '',
	seo_meta_title_videolist: 'NBA | Senarai Video',
	seo_meta_desc_videolist: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA | Rancangan NBA TV',
	seo_meta_desc_shows: '',
	seo_meta_keywords_shows: '',
	seo_meta_title_home: 'Laman NBA',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'NBA | Saluran',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'NBA | Saluran',
	seo_meta_pre_title_categories: 'NBA | Kategori',
	seo_meta_title_categories: 'NBA | {0}',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'NBA | Kategori',
	seo_meta_title_category: 'NBA | {0}',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'NBA | Video',
	seo_meta_pre_title_event: 'NBA | Acara',
	seo_meta_title_events: 'NBA | Acara',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'NBA | Acara: {0}',
	seo_meta_desc_event: '',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'NBA | Cari',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'NBA | Laman Tidak Ditemui',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Perlawanan NBA:',
	seo_meta_title_game: 'NBA | {0}',
	seo_meta_desc_game: '',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'NBA | Video dan Sorotan NBA',
	seo_meta_desc_video: 'Video NBA menampilkan video dan sorotan NBA',
	seo_meta_keywords_video: 'Video NBA, Sorotan NBA, Video Bola Keranjang, perlawanan penting, dunk, ciri-ciri',
	seo_meta_title_channel: 'NBA | Siaran Langsung NBA TV',
	seo_meta_desc_channel: 'NBA TV Siaran Langsung membawakan anda saluran NBA TV 24 jam sehari dengan penstriman perlawanan NBA secara langsung dan dari arkib setiap minggu, jadual program Studio dan liputan penganalisis',
	seo_meta_keywords_channel: 'Saluran NBA TV, rentak perlawanan, program Hardwood Classics, NBA siaran langsung, program NBA Gametime, tinjauan fantasi, rancangan studio, program the Jump',
	seo_meta_title_tvguide: 'NBA | Jadual NBA TV',
	seo_meta_desc_tvguide: 'NBA TV Siaran Langsung membawakan anda saluran NBA TV 24 jam sehari dengan penstriman perlawanan NBA secara langsung dan dari arkib setiap minggu, jadual program Studio dan liputan penganalisis',
	seo_meta_keywords_tvguide: 'Saluran NBA TV, rentak perlawanan, program Hardwood Classics, NBA siaran langsung, program NBA Gametime, tinjauan fantasi, rancangan studio, program the Jump',
	timezone: 'ET',
	default_feed_error_message: 'Ada yang tidak kena, kandungan tidak tersedia sekarang. Anda boleh cuba semula.',
	watch_in_app: 'TONTON DI APLIKASI NBA',
	no_content: 'Tiada Kandungan',
	see_more: 'Lihat Lagi',
	now_playing: 'KINI DITAYANGKAN',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'PREMIUM LP',
	error_max_limit_favorite: 'Anda telah mencapai bilangan maksimum bagi video kegemaran. Buang beberapa video kegemaran sebelum menambah lagi.',
	item_live: 'Langsung',
	add_favourite_title: 'TAMBAH KE FAVORITE',
	remove_favourite_title: 'KELUARKAN DARI FAVORITE',
	p_channel_live: 'Langsung',
	p_channel_schedule_title: 'Jadual NBA TV',
	p_channel_schedule_watch: 'Tonton',
	p_channel_schedule_no_date: 'Tiada Tarikh Jadual tersedia buat masa ini.',
	p_channel_live24x7_title: 'NBA TV 24/7',
	p_channel_live24x7_see_full_schedule: 'Lihat Jadual Penuh',
	p_channel_live24x7_up_next: 'seterusnya',
	p_channel_live24x7_on_demand: 'NBA TV: Atas Permintaan',
	p_channel_live24x7_collection: 'Koleksi',
	p_channel_live24x7_demand_1_logo_text: 'rancangan asli',
	p_channel_live24x7_demand_1_show_name: 'Rancangan NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'Rancangan NBA TV yang asli termasuk Shaqtin \'a Fool, Beyond the Paint, Game Time dan Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Perlawanan klasik',
	p_channel_live24x7_demand_2_show_name: 'NBA | Perlawanan Klasik',
	p_channel_live24x7_demand_2_show_desc: 'Tonton Perlawanan Klasik yang penuh, termasuk semua pertandingan akhir sejak tahun 2000, detik-detik bersejarah liga dan pemain legenda',
	p_channel_clips_title: 'Klip NBA TV',
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Jadual',
	p_nba_tv_shows: 'Rancangan NBA TV',
	p_nba_tv_no_access_title: '24/7 NBA: Dapatkan maklumat terkini analisis perlawanan, analisis studio, rancangan asli, dan banyak lagi!',
	p_nba_tv_no_access_desc: 'Tonton perlawanan secara langsung serta rancangan dan perlawanan klasik atas permintaan.',
	p_nba_tv_no_access_note: 'Tertakluk kepada sekatan',
	tv_show_item_latest_episode: 'episod terkini',
	tv_show_item_no_latest_episode: 'tiada episod terkini',
	see_all: 'Lihat Semua',
	header_menu_watch: 'Tonton',
	header_menu_featured: 'SOROTAN',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',
	players: 'Pemain',
	videos: 'Video',
	teams: 'Pasukan',
	most_searched: 'PALING BANYAK DICARI',
	no_result: 'Tiada Data',
	searchfilter_type_most_relevant: 'Paling relevan',
	searchfilter_type_most_viewed: 'Paling banyak ditonton',
	searchfilter_type_most_recent: 'Yang terkini',
	searchfilter_type_last_30_days: '30 hari terakhir',
	searchfilter_type_last_6_months: '6 bulan terakhir',
	searchresult_label: 'Hasil carian untuk \'{keyword}\'',
	searchresult_info: 'Lihat semua hasil carian untuk {keyword}',
	searchplaceholder: 'Cari di pustaka video',
	load_more: 'Memuatkan Lagi...',
	button_subscribe: 'Melanggan',
	button_sign_in: 'Log Masuk',
	p_league_pass_no_access_title: 'Tonton perlawanan secara langsung atau ulangan di mana-mana peranti, termasuk komputer, telefon pintar dan TV anda!',
	p_league_pass_no_access_desc: 'Tiket untuk aksi terkini: tonton kesemua liga atau pasukan kegemaran anda, pilih perlawanan tunggal, atau lihat pilihan-pilihan lain.',
	p_league_pass_no_access_note: 'Tertakluk kepada terma',
	category_title: 'Video',
	p_video_playlist_title: 'Senarai main',
	p_no_access_league_pass_title: 'Buka NBA League Pass untuk menonton:',
	p_no_access_league_pass_desc: 'Tiket untuk aksi terkini: tonton kesemua liga atau pasukan kegemaran anda, pilih perlawanan tunggal, atau lihat pilihan-pilihan lain.',
	p_no_access_league_pass_terms: 'Tertakluk kepada terma',
	p_no_access_league_pass_geo_desc: 'Berdasarkan lokasi semasa, anda tidak dapat menonton perlawanan ini melalui NBA League Pass dan NBA TV. Arkib perlawanan ini akan tersedia 3 hari selepas disiarkan untuk pelanggan NBA League Pass. Sila rujuk jadual siaran TV dan radio tempatan untuk mengetahui siaran di kawasan anda.',
	p_no_access_league_pass_not_found_desc: 'Maaf, video yang anda cari tidak ditemui.',
	p_no_access_event_not_found_desc: 'Maaf, acara yang anda cari tidak ditemui.',
	p_no_access_nba_tv_title: 'Buka NBA TV untuk menonton:',
	p_no_access_nba_tv_desc: 'Tonton perlawanan secara langsung serta rancangan dan permainan klasik atas permintaan.',
	p_no_access_nba_tv_terms: 'Tertakluk kepada terma',
	p_no_access_nba_tv_geo_desc: 'Berdasarkan lokasi semasa, anda tidak dapat menonton perlawanan ini melalui NBA League Pass dan NBA TV. Arkib perlawanan ini akan tersedia 3 hari selepas disiarkan untuk pelanggan NBA League Pass. Sila rujuk jadual siaran TV dan radio tempatan untuk mengetahui siaran di kawasan anda.',
	p_no_access_nba_tv_not_found_desc: 'Maaf, saluran yang anda cari tidak ditemui.',
	p_no_access_up_next: 'Seterusnya:',
	p_video_completed_title: 'Senarai Main Lengkap',
	p_video_completed_desc: 'Kembali melayar atau lihat senarai main seterusnya untuk anda',
	p_video_share_to: 'Kongsi ke:',
	p_video_more_to_watch: 'Lebih banyak untuk Ditonton:',
	p_event_section_title: 'Acara',
	p_event_playlist_title: 'Senarai main',
	p_event_button_watch: 'Tonton',
	p_event_button_listen: 'Dengar',
	p_event_button_ticket: 'Tiket',
	notfound: 'Maaf, halaman yang anda minta tidak dijumpai.',
	notfound_desc: 'Sila semak URL untuk kesilapan.<br/> Anda juga boleh cuba menggunakan navigasi tapak atau alat carian untuk mencari kandungan anda.',
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Akaun NBA League Pass anda telah mencapai bilangan penstriman maksimum. Klik \'Teruskan\' untuk terus menonton dengan peranti ini.',
	modal_pcm_custom: 'Teruskan',
	modal_pcm_close: 'Batal',
	modal_adobe_concurrency_header_title: 'Hilang Sambungan Video',
	modal_adobe_concurrency_body_title: '',
	modal_adobe_concurrency_body_description: 'Strim anda telah ditutup. Antara sebab lain termasuklah melebihi had aliran serentak maksimum, kehilangan rangkaian atau kesilapan teknikal. Sila log masuk semula dan pilih saluran untuk teruskan.',
	modal_adobe_concurrency_close: 'Selesai',
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Video ini tidak boleh dimainkan pada peranti anda. Klik <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>DI SINI</a> untuk bantuan lanjut.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'OK',
	freesample_notice_time: 'Masa yang tinggal',
	freesample_notice_title: 'Nikmati Akses {0} Minit Anda',
	freesample_notice_desc: 'Langgan pakej penuh League Pass untuk terus mengakses kandungan selepas {0} minit anda tamat.',
	freesample_notice_subscribe_button: 'Melanggan',
	freesample_notice_cancel_button: 'BATALKAN PADA BILA-BILA MASA',
	freesample_popup_title: 'AKSES ANDA TELAH TAMAT',
	freesample_popup_subtitle: 'Langgan League Pass untuk menonton lebih banyak kandungan hebat NBA.',
	freesample_popup_link: 'KETAHUI LEBIH LANJUT!',
	freesample_popup_get_minutes_button: 'DAPATKAN {0}  MINIT',
	reg_required_desc: 'Anda perlu log masuk untuk melihat kandungan ini',
	favorite_teams_title: 'Pasukan Kegemaran',
	bookmarked_title: 'Disimpan',
	watch_history_title: 'Teruskan Menonton',
	game_schedule_title: 'Jadual Perlawanan',
	recommended_title: 'Disyorkan',
	season_text: 'Musim',
	section_tv_provider_title: 'Penyedia TV Saya',
	section_tv_provider_desc: 'Dapatkan akses ke perlawanan dan strim secara langsung oleh penyedia tv anda.',
	section_tv_provider_faq: 'Soalan Lazim Penyedia TV',
	section_tv_provider_sign_out: 'Log Keluar',
	header_menu_account_my_account: 'Akaun Saya',
	header_menu_account_manage_account: 'Urus Akaun',
	header_menu_account_favorite_teams: 'Pasukan Kegemaran',
	header_menu_account_favorite_players: 'Pemain Kegemaran',
	header_menu_account_viewing_history: 'Sejarah Tontonan',
};
